import { SystemField } from "./system-field";

export class Warehouse extends SystemField {
     
     code?:string;
     is_active?:number;
     desc?:string;
     name?:string;
     freeze_inventory?:number;
     note?:string;
}
